export { default } from './BadgeImage';
